module.exports = __webpack_public_path__ + "static/media/stomach.9ece4ad3.svg";